export enum KnowledgeBaseViewMode {
  List = 'list',
  Grid = 'grid'
}
